import { MutationKey } from '@tanstack/query-core';

import { services2 } from '/api/services2';

export const { appConfigService } = services2;
export const appConfigServiceName: string = appConfigService.getClassName();

export const retrieveConfigMutationKey: MutationKey = ['service', 'config', 'retrieve'];
